@if ((useLazyLoad || isLoaded) && !isIncomplete) {
  <sd-tips
    [content]="content"
    [title]="title"
    [icon]="icon"
    [sdSpyTarget]="componentUid"
    [titleLevel]="titleLevel"
    [brand]="brandCorner"
    [isLoading]="useLazyLoad && !isLoaded"
  />
}
